//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import commonload from "@/pcpage/hr/common/commonload";
import portalFileList from "@/pcpage/hr/recruitment/portal/component/portalFileList";
export default {
  extends: commonload,
  name: "offerprocess",
  components: {
    portalFileList
  },
  data() {
    return {
      mobileAlert:
        "To view offer details, please switch to full-size desktop website",
      taxList: [],
      isEdit: "false",
      editItems: "",
      showMore: true,
      showMoreFlowList: [],
      showLessFlowList: [],
      currentYear: "",
      approvalList: [],
      yesOrNoList: [],
      approvalDialogVisible: false,
      activeName: "first",
      action: "03",
      processFlowList: [],
      processProcessList: [],
      selectFlow: "",
      selectProcessor: "",
      selectComment: "",
    };
  },
  methods: {
    /**
     *  页面初始化
     */
    async init() {
      this.initParam();
      this.initSelect();
      // this.getNowTime();
      // this.initTax();
    },
    /**
     *  初始化参数
     */
    initParam() {
      this.loadAddAction = "/api/api/findOfferProcessSheet";
    },

    /**
     *  获取当前年份
     */
    getNowTime: function () {
      this.currentYear = new Date().getFullYear();
    },

    /**
     *  初始化税务数据
     */
    async initTax() {
      let url = "/api/api/findTrainTax";
      let params = {
        year: this.currentYear,
      };
      await this.axios.post(url, params).then(({ data }) => {
        if (data.code == 1) {
          this.taxList = data.data.record;
          // 初始化计算
          this.calculate("currentPackage1");
          this.calculate("currentPackage2");
          this.calculateDito("dito1");
          this.calculateDito("dito2");
        }
      });
    },

    /**
     *  增加行项
     */
    // offerSheetAdd (date) {
    //     if(this.isEdit) {
    //         this.addrow(date);
    //         this.autoScroll();
    //     }
    // },

    /**
     *  删除行项
     */
    // offerSheetDel (index, row, date, delDate) {
    //     if(this.isEdit) {
    //         this.delrow(index, row, date,'id', delDate)
    //     }
    // },

    /**
     *  初始化下拉框值
     */
    async initSelect() {
      let rangeApproval = {
        showcode: "approvalList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "OFFER_PROCESS_APPROVAL",
          paras1: "1",
        },
      };
      let typeParams = [];
      typeParams.push(rangeApproval);
      this.initDropDown(this, typeParams);

      let yesOrNo = {
        showcode: "yesOrNoList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "YESORNO",
          paras1: "1",
        },
      };
      typeParams.push(yesOrNo);
      this.initDropDown(this, typeParams);
    },

    async viewTax() {
      let oQuery = {};
      let routerpath = "/portal/offerprocesstaxtable";
      oQuery["year"] = this.currentYear;
      this.openWin(routerpath, oQuery);
    },

    /**
     *  Approval/Return 标签页切换
     */
    // handleClick(tab, event) {
    //     if(tab.name == 'first') {
    //         this.action = '03';
    //     } else {
    //         this.action = '04';
    //     }
    //     this.approvalDialogOpen();
    // },

    /**
     *  流程状态选择
     */
    // async flowChange(processFlow) {
    //     this.processProcessList = processFlow.offerProcessorList;
    //     this.selectProcessor = this.processProcessList[0].value;
    // },

    /**
     *  dialog打开初始化
     */
    // async approvalDialogOpen() {
    //     let url = "bhiringofferprocess/findFlowAndProcessor";
    //     let params = {
    //         action: this.action,
    //         currentflow: this.record.currentflow,
    //         applicationno: this.record.applicationno
    //     };
    //     await this.axios.post(url, params).then(({ data }) => {
    //         if (data.code == '1') {
    //             this.processFlowList = data.data.record;
    //             if(this.processFlowList.length > 0) {
    //                 this.processProcessList = this.processFlowList[0].offerProcessorList;
    //                 this.selectFlow = this.processFlowList[0].value;
    //             }
    //             if(this.processProcessList.length > 0) {
    //                 this.selectProcessor = this.processProcessList[0].value;
    //             }
    //             this.selectComment = '';
    //         }
    //     })
    // },

    /**
     *  dialog关闭后初始化
     */
    // async approvalDialogClose() {
    //     this.action = '03';
    //     this.activeName = 'first';
    //     this.selectComment = '';
    // },

    // async approvalOrReturnOffer() {
    //     this.approvalDialogVisible = false;
    //     this.record.action = this.action;
    //     this.record.comment = this.selectComment;
    //     this.record.flow = this.record.currentflow;
    //     this.record.currentprocessor = this.selectProcessor;
    //     this.record.currentflow = this.selectFlow;
    //     let params = {
    //         act: 'submit',
    //         record: this.record
    //     };
    //     await formValidate.bindRules4NotFlow(this, 'submit');
    //     await formValidate.clearFormValidateTip(this);
    //     this.formTipArray.length = 0;
    //     this.$nextTick(() => {
    //         Promise.all(this.buildForms())
    //         .then(async () => {
    //             await this.axios.post(this.saveAction, params).then(({ data }) => {
    //                 if (data.code == '1') {
    //                     this.params = data.data.params;
    //                     this.$router.push({
    //                         path: this.currRouterPath,
    //                         query: this.params
    //                     });
    //                     var returnParams = this.params;
    //                     for (var key in returnParams) {
    //                         //遍历json对象的每个key/value对,p为key
    //                         console.info(key + " " + returnParams[key]);
    //                         this.record[key] = returnParams[key];
    //                     }
    //                     this.tipSuccess(this.$t("hrcommon.submitsuccess"));
    //                     this.doLoadRecordNot4Flow();
    //                     window.opener.location.reload();
    //                 }
    //             })
    //         })
    //         .catch(error => {
    //             if(this.formTipArray.length > 0){
    //                 let oFormValidateTip = this.formErrorTip2(
    //                     this.$t("flow_process.msgtitle"),
    //                     this.formTipArray
    //                 );
    //                 formValidate.pushFormValidateTip(this, oFormValidateTip);
    //             }else{
    //                 this.tipError(this.$t("flow_process.saveerror2"));
    //             }
    //         });
    //     });
    // },

    /**
     *  save之前的数据校验
     */
    // async beforesave(){
    //     return true;
    // },

    /**
     *  展示更多/更少按钮功能
     */
    async showMoreOrLess(type) {
      if (type == "More") {
        this.showMore = false;
        this.$set(this.record, "processFlowList", this.showMoreFlowList);
      } else {
        this.showMore = true;
        this.$set(this.record, "processFlowList", this.showLessFlowList);
      }
    },

    /**
     *  下载附件
     */
    async download(link) {
      let url = "api/api/portalFile/download";
      let params = {
        fileid: link.uuid,
        filename: link.filename,
        url: link.attlink,
        uuid: link.uuid,
      };
      this.axios
        .posttype(url, { record: params }, "arraybuffer")
        .then((res) => {
          let blob = new Blob([res.data]);
          let url = window.URL.createObjectURL(blob); //表示一个指定的file对象或Blob对象
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = link.filename; //命名下载名称
          a.click(); //点击触发下载
          window.URL.revokeObjectURL(url); //下载完成进行释放
          document.body.removeChild(a);
        })
        .catch((error) => console.log(error));
    },

    /**
     *  数据加载后处理
     */
    async doLoadRecordAfter(oQuery, data) {
      this.showMoreFlowList = [];
      this.showLessFlowList = [];
      let record = data.data.record;
      // this.isEdit = record.isEdit;
      // if(this.isEdit) {
      //     this.editItems = ';XXXX;';
      // }
      this.getFlowList(record, 4);

      // 获取年份
      let time = record.createtime;
      let timeList = time.split("-");
      this.currentYear = timeList[2];
      // this.initTax();
    },

    /**
     *  查询的流程信息处理
     */
    async getFlowList(record, index) {
      let flowList = record.processFlowList;
      if (flowList.length > 0) {
        for (let i = 0; i < flowList.length; i++) {
          this.showMoreFlowList.push(flowList[i]);
          if (index > i) {
            this.showLessFlowList.push(flowList[i]);
          }
        }
        record.processFlowList = this.showLessFlowList;
      }
    },

    /**
     *  处理计算的精度问题
     */
    async formatNum(f, digit) {
      var m = Math.pow(10, digit);
      return parseInt(f * m, 10) / m;
    },

    /**
     *  计算数值 Current Package
     */
    async calculate(type) {
      if (type == "currentPackage1") {
        let currentPackage1 = this.record.currentPackage1;
        if (currentPackage1.length > 0) {
          let packageYesTaxableTotal = 0;
          let packageNoTaxableTotal = 0;
          let packageAnnualIncome = 0;
          let b1 = 0;
          for (let i = 0; i < currentPackage1.length; i++) {
            let annual;
            let yesTaxable = this.cal.accAdd(0, 0).toFixed(2);
            let noTaxable = this.cal.accAdd(0, 0).toFixed(2);
            let monthly;
            if (currentPackage1[i].monthly) {
              monthly = currentPackage1[i].monthly;
            } else {
              monthly = this.cal.accAdd(0, 0).toFixed(2);
            }
            switch (i) {
              case 0:
                b1 = monthly;
                annual = this.cal.accMul(monthly, 12).toFixed(2);
                break;
              case 1:
                annual = this.cal.accMul(monthly, b1).toFixed(2);
                break;
              case 4:
                if (
                  currentPackage1[i].monthly &&
                  currentPackage1[i].monthly == "1"
                ) {
                  annual = this.cal
                    .accMul(this.cal.accMul(b1, 12), 0.15)
                    .toFixed(2);
                } else {
                  annual = this.cal.accAdd(0, 0).toFixed(2);
                }
                break;
              default:
                annual = this.cal.accMul(monthly, 12).toFixed(2);
                break;
            }
            if (
              currentPackage1[i].taxable &&
              currentPackage1[i].taxable == "1"
            ) {
              yesTaxable = annual;
            } else if (
              currentPackage1[i].taxable &&
              currentPackage1[i].taxable == "0"
            ) {
              noTaxable = annual;
            }
            packageYesTaxableTotal = this.cal
              .accAdd(packageYesTaxableTotal, yesTaxable)
              .toFixed(2);
            packageNoTaxableTotal = this.cal
              .accAdd(packageNoTaxableTotal, noTaxable)
              .toFixed(2);
            if (i < 5) {
              packageAnnualIncome = this.cal
                .accAdd(
                  this.cal.accAdd(packageAnnualIncome, yesTaxable),
                  noTaxable
                )
                .toFixed(2);
            }
            this.$set(this.record.currentPackage1[i], "annual", annual);
            this.$set(this.record.currentPackage1[i], "yesTaxable", yesTaxable);
            this.$set(this.record.currentPackage1[i], "noTaxable", noTaxable);
          }
          this.$set(
            this.record,
            "packageYesTaxableTotal",
            packageYesTaxableTotal
          );
          this.$set(
            this.record,
            "packageNoTaxableTotal",
            packageNoTaxableTotal
          );
          this.$set(this.record, "packageAnnualIncome", packageAnnualIncome);
        }
      } else if (type == "currentPackage2") {
        let currentPackage2 = this.record.currentPackage2;
        let package2Total = 0;
        if (currentPackage2.length > 0) {
          for (let i = 0; i < currentPackage2.length; i++) {
            let monthly;
            if (currentPackage2[i].monthly) {
              monthly = currentPackage2[i].monthly;
            } else {
              monthly = this.cal.accAdd(0, 0).toFixed(2);
            }
            let annual = this.cal.accMul(monthly, 12).toFixed(2);
            this.$set(this.record.currentPackage2[i], "annual", annual);
            package2Total = this.cal.accAdd(package2Total, annual).toFixed(2);
          }
          this.$set(this.record, "package2Total", package2Total);
        }
      }

      // Current Package
      let packageAnnualIncome = this.cal.accAdd(0, 0).toFixed(2);
      if (this.record.packageAnnualIncome) {
        packageAnnualIncome = this.record.packageAnnualIncome;
      }
      let packageYesTaxableTotal = this.cal.accAdd(0, 0).toFixed(2);
      if (this.record.packageYesTaxableTotal) {
        packageYesTaxableTotal = this.record.packageYesTaxableTotal;
      }
      let package2Total = this.cal.accAdd(0, 0).toFixed(2);
      if (this.record.package2Total) {
        package2Total = this.record.package2Total;
      }
      let packageTaxableIncome = this.cal
        .accSub(packageYesTaxableTotal, package2Total)
        .toFixed(2);
      this.$set(this.record, "packageTaxableIncome", packageTaxableIncome);
      // todo 税收表出现 在计算
      let packageTaxDue = await this.calculateTaxDue(
        Number(packageTaxableIncome)
      );
      this.$set(this.record, "packageTaxDue", packageTaxDue);

      this.$set(
        this.record,
        "packageAnnualNet",
        this.cal.accSub(packageAnnualIncome, packageTaxDue).toFixed(2)
      );

      let ditoAnnualIncome = this.cal.accAdd(0, 0).toFixed(2);
      if (this.record.ditoAnnualIncome) {
        ditoAnnualIncome = this.record.ditoAnnualIncome;
      }
      let grossAnnualIncome = this.cal.accAdd(0, 0).toFixed(2);
      if (ditoAnnualIncome != 0) {
        grossAnnualIncome = this.cal
          .accMul(
            this.cal.accDiv(
              this.cal.accSub(ditoAnnualIncome, packageAnnualIncome),
              ditoAnnualIncome
            ),
            100
          )
          .toFixed(2);
      }
      this.$set(this.record, "grossAnnualIncome", grossAnnualIncome + "%");
    },

    /**
     *  计算数值 DITO
     */
    async calculateDito(type) {
      if (type == "dito1") {
        let dito1 = this.record.dito1;
        if (dito1.length > 0) {
          let ditoYesTaxableTotal = 0;
          let ditoNoTaxableTotal = 0;
          let ditoAnnualIncome = 0;
          let b1 = 0;
          for (let i = 0; i < dito1.length; i++) {
            let annual;
            let yesTaxable = this.cal.accAdd(0, 0).toFixed(2);
            let noTaxable = this.cal.accAdd(0, 0).toFixed(2);
            let monthly;
            if (dito1[i].monthly) {
              monthly = dito1[i].monthly;
            } else {
              monthly = this.cal.accAdd(0, 0).toFixed(2);
            }
            switch (i) {
              case 0:
                b1 = monthly;
                annual = this.cal.accMul(monthly, 12).toFixed(2);
                break;
              case 1:
                annual = this.cal.accMul(monthly, b1).toFixed(2);
                break;
              case 4:
                if (dito1[i].monthly && dito1[i].monthly == "1") {
                  annual = this.cal
                    .accMul(this.cal.accMul(b1, 12), 0.15)
                    .toFixed(2);
                } else {
                  annual = this.cal.accAdd(0, 0).toFixed(2);
                }
                break;
              default:
                annual = this.cal.accMul(monthly, 12).toFixed(2);
                break;
            }
            if (dito1[i].taxable && dito1[i].taxable == "1") {
              yesTaxable = annual;
            } else if (dito1[i].taxable && dito1[i].taxable == "0") {
              noTaxable = annual;
            }
            ditoYesTaxableTotal = this.cal
              .accAdd(ditoYesTaxableTotal, yesTaxable)
              .toFixed(2);
            ditoNoTaxableTotal = this.cal
              .accAdd(ditoNoTaxableTotal, noTaxable)
              .toFixed(2);
            if (i < 5) {
              ditoAnnualIncome = this.cal
                .accAdd(
                  this.cal.accAdd(ditoAnnualIncome, yesTaxable),
                  noTaxable
                )
                .toFixed(2);
            }
            this.$set(this.record.dito1[i], "annual", annual);
            this.$set(this.record.dito1[i], "yesTaxable", yesTaxable);
            this.$set(this.record.dito1[i], "noTaxable", noTaxable);
          }
          this.$set(this.record, "ditoYesTaxableTotal", ditoYesTaxableTotal);
          this.$set(this.record, "ditoNoTaxableTotal", ditoNoTaxableTotal);
          this.$set(this.record, "ditoAnnualIncome", ditoAnnualIncome);
        }
      } else if (type == "dito2") {
        let dito2 = this.record.dito2;
        let dito2Total = 0;
        if (dito2.length > 0) {
          for (let i = 0; i < dito2.length; i++) {
            let monthly;
            if (dito2[i].monthly) {
              monthly = dito2[i].monthly;
            } else {
              monthly = this.cal.accAdd(0, 0).toFixed(2);
            }
            let annual = this.cal.accMul(monthly, 12).toFixed(2);
            this.$set(this.record.dito2[i], "annual", annual);
            dito2Total = this.cal.accAdd(dito2Total, annual).toFixed(2);
          }
          this.$set(this.record, "dito2Total", dito2Total);
        }
      }

      // Current Package
      let ditoAnnualIncome = this.cal.accAdd(0, 0).toFixed(2);
      if (this.record.ditoAnnualIncome) {
        ditoAnnualIncome = this.record.ditoAnnualIncome;
      }
      let ditoYesTaxableTotal = this.cal.accAdd(0, 0).toFixed(2);
      if (this.record.ditoYesTaxableTotal) {
        ditoYesTaxableTotal = this.record.ditoYesTaxableTotal;
      }
      let dito2Total = this.cal.accAdd(0, 0).toFixed(2);
      if (this.record.dito2Total) {
        dito2Total = this.record.dito2Total;
      }
      let ditoTaxableIncome = this.cal
        .accSub(ditoYesTaxableTotal, dito2Total)
        .toFixed(2);
      this.$set(this.record, "ditoTaxableIncome", ditoTaxableIncome);
      // todo 税收表出现 在计算
      let ditoTaxDue = await this.calculateTaxDue(Number(ditoTaxableIncome));
      this.$set(this.record, "ditoTaxDue", ditoTaxDue);

      this.$set(
        this.record,
        "ditoAnnualNet",
        this.cal.accSub(ditoAnnualIncome, ditoTaxDue).toFixed(2)
      );

      let basicSalaryMonthly = this.cal.accAdd(0, 0).toFixed(2);
      if (this.record.dito1[0].monthly) {
        basicSalaryMonthly = this.record.dito1[0].monthly;
      }
      this.$set(
        this.record,
        "ditoNetPayBasic",
        this.cal
          .accSub(basicSalaryMonthly, this.cal.accDiv(ditoTaxDue, 12))
          .toFixed(2)
      );

      let carAllowance = this.cal.accAdd(0, 0).toFixed(2);
      if (this.record.dito1[3].monthly) {
        carAllowance = this.record.dito1[3].monthly;
      }
      this.$set(
        this.record,
        "ditoNetPayBasicAllowances",
        this.cal
          .accSub(
            this.cal.accAdd(basicSalaryMonthly, carAllowance),
            this.cal.accDiv(ditoTaxDue, 12)
          )
          .toFixed(2)
      );

      let packageAnnualIncome = this.cal.accAdd(0, 0).toFixed(2);
      if (this.record.packageAnnualIncome) {
        packageAnnualIncome = this.record.packageAnnualIncome;
      }
      let grossAnnualIncome = this.cal.accAdd(0, 0).toFixed(2);
      if (ditoAnnualIncome != 0) {
        grossAnnualIncome = this.cal
          .accMul(
            this.cal.accDiv(
              this.cal.accSub(ditoAnnualIncome, packageAnnualIncome),
              ditoAnnualIncome
            ),
            100
          )
          .toFixed(2);
      }
      this.$set(this.record, "grossAnnualIncome", grossAnnualIncome + "%");
    },

    /**
     *  计算Tax Due
     */
    async calculateTaxDue(grossTableIncome) {
      let taxDue = this.cal.accAdd(0, 0).toFixed(2);
      if (this.taxList.length > 0) {
        for (let i = 0; i < this.taxList.length; i++) {
          let incomebegin = this.taxList[i].incomebegin;
          if (grossTableIncome > incomebegin) {
            let offsetvalue = 0;
            if (this.taxList[i].offsetvalue) {
              offsetvalue = this.taxList[i].offsetvalue;
            }
            let rate = 0;
            if (this.taxList[i].rate) {
              rate = this.taxList[i].rate;
            }
            let addtionvalue = 0;
            if (this.taxList[i].addtionvalue) {
              addtionvalue = this.taxList[i].addtionvalue;
            }
            taxDue = this.cal
              .accAdd(
                this.cal.accMul(
                  this.cal.accMul(
                    this.cal.accSub(grossTableIncome, offsetvalue),
                    rate
                  ),
                  0.01
                ),
                addtionvalue
              )
              .toFixed(2);
          }
        }
        return taxDue;
      } else {
        return taxDue;
      }
    },
    doLoadRecordBefore: function (oQuery, reuestParams) {
      oQuery.record.uuid = reuestParams.applicationUuid;
      // oQuery.record.uuid = '91e6fd833ddb11ecb61c000c29f26c40';
      return true;
    },
  },
  created() {
    this.init().then(() => {
      this.doLoadRecordNot4Flow();
    });
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/offerprocess.vue